export default function Hero() {
  return (
    <section className="relative min-h-screen flex items-center justify-center bg-white pt-20">
      <div className="absolute inset-0 z-0">
        <img
          src="https://public.readdy.ai/ai/img_res/1ebddde3e2728ec1eb8d961940f8c137.jpg"
          alt="Distribution Center"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-6 text-center">
        <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight">
          Local Snack Distribution for Independent Stores in Sonoma County.
        </h1>
        <p className="text-xl md:text-2xl text-white/95 mb-8 max-w-3xl mx-auto font-light">
          We place, restock, and manage shelf-ready products. You only pay for what moves.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <a
            href="#store-inquiry"
            className="px-8 py-4 bg-white text-gray-900 text-base font-semibold rounded-md hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer w-full sm:w-auto"
          >
            Request Product Placement
          </a>
          <a
            href="#producer-inquiry"
            className="px-8 py-4 bg-transparent border-2 border-white text-white text-base font-semibold rounded-md hover:bg-white/10 transition-colors whitespace-nowrap cursor-pointer w-full sm:w-auto"
          >
            Apply for Distribution
          </a>
        </div>
      </div>
    </section>
  );
}